<div [formGroup]="formGroup">
    <div formGroupName="{{formGroupName}}">
        <div class="address-form-item">
            <mat-form-field class="full-line" ngClass.xs="mobile-full-line">
                <mat-label>{{addressName}} 1</mat-label>
                <input matInput formControlName="line_1" maxlength="255">
            </mat-form-field>
        </div>
        <div class="address-form-item">
            <mat-form-field class="full-line" ngClass.xs="mobile-full-line">
                <mat-label>{{addressName}} 2</mat-label>
                <input matInput formControlName="line_2" maxlength="255">
            </mat-form-field>
        </div>
        <div class="address-form-item">
            <table cellspacing="0">
                <tr>
                    <td>
                        <mat-form-field class="half-line" ngClass.xs="mobile-quarter-line">
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city" maxlength="255">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="quarter-line" ngClass.xs="mobile-quarter-line">
                            <mat-label>State</mat-label>
                            <input matInput formControlName="state_province_county" maxlength="255">
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="quarter-line" ngClass.xs="mobile-quarter-line-postal">
                            <mat-label>Postal Code</mat-label>
                            <input matInput #postalCode maxlength="5" formControlName="zip_postcode">
                            <mat-hint align="end">{{postalCode.value.length}} / 5</mat-hint>
                        </mat-form-field>
                    </td>
                </tr>
            </table>
        </div>
        <div class="address-form-item">
            <mat-form-field class="full-line" ngClass.xs="mobile-full-line">
                <mat-label>Country</mat-label>
                <input matInput formControlName="country">
            </mat-form-field>
        </div>
    </div>
</div>
